import React from "react";
import {Link} from "react-router-dom";

const BlogCard = ({image, readTime, date, title, slug, author}) => {
    function formatDate(date) {
        if (!date) return "Date not available";
        const d = new Date(date);
        return d
            .toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
            })
            .replace(/ (\w{3}) /, " $1, ");
    }

    if (!slug) {
        return null;
    }

    return (
        <Link to={`/blogs/${slug}`} className="w-full overflow-hidden hover:opacity-90 transition-opacity">
            <div className="relative w-full h-64 rounded-2xl overflow-hidden">
                {/* Blurred background */}
                <div
                    className="absolute inset-0 bg-center bg-no-repeat bg-cover filter blur-xl scale-110"
                    style={{backgroundImage: `url(${image})`}}
                ></div>

                {/* Full image on top */}
                <img
                    src={image}
                    alt={title}
                    className="relative w-full h-full object-contain rounded-2xl"
                />
            </div>

            <div className="mt-3 px-1">
                <div className="flex items-center justify-between text-gray-500 text-sm">
                    <span>{author && `By ${author}`}</span>
                    <span>{formatDate(date)}</span>
                </div>
                <div className="flex items-center text-gray-500 text-sm mt-1">
                    <span>{readTime || "2 min read"}</span>
                </div>
                <h3 className="mt-1 text-lg font-medium text-gray-900">{title}</h3>
            </div>
        </Link>
    );
};

export default BlogCard;